interface DartboardSVGProps {
  color: string;
  style: React.CSSProperties;
}

const DartboardSVG = ({ color, style }: DartboardSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="52"
    height="52"
    viewBox="0 0 52 52"
    fill="none"
  >
    <g clipPath="url(#clip0_1584_46249)">
      <path
        d="M39.0874 12.9126V7.44578L44.5542 1.979V7.44578"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M39.0874 12.9125H44.5542L50.021 7.44574H44.5542"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M42.3676 30.4062C42.3676 41.8755 33.0631 51.18 21.5938 51.18C10.1245 51.18 0.820068 41.8755 0.820068 30.4062C0.820068 18.9369 10.1245 9.63245 21.5938 9.63245"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M42.3676 30.4062C42.3676 24.6771 40.0387 19.4727 36.2776 15.7225"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M33.7737 13.5904C30.3515 11.0975 26.1421 9.63245 21.5938 9.63245"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M36.9008 30.4062C36.9008 38.8579 30.0455 45.7132 21.5938 45.7132C13.1422 45.7132 6.28687 38.8579 6.28687 30.4062C6.28687 21.9546 13.1422 15.0992 21.5938 15.0992"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M36.9007 30.4063C36.9007 26.1859 35.1842 22.3592 32.418 19.582"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M29.8486 17.5156C27.4651 15.9849 24.6333 15.0992 21.5938 15.0992"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M31.4341 30.4062C31.4341 35.8402 27.0278 40.2464 21.5939 40.2464C16.1599 40.2464 11.7537 35.8402 11.7537 30.4062C11.7537 24.9723 16.1599 20.566 21.5939 20.566"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M25.836 21.5282C24.5567 20.9159 23.1135 20.566 21.5938 20.566"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M24.6881 27.3121C25.4753 28.1102 25.9673 29.2036 25.9673 30.4063C25.9673 32.8226 24.0102 34.7797 21.5939 34.7797C19.1776 34.7797 17.2205 32.8226 17.2205 30.4063C17.2205 27.9899 19.0354 26.1859 21.3205 26.0438"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M21.5938 30.4063L50.021 1.979"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </g>
    <defs>
      <clipPath id="clip0_1584_46249">
        <rect width="52" height="52" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default DartboardSVG;
